var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmericanExpress = function SvgAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 40,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0690FF",
    d: "M120 76v-8.676h-9.651l-4.969-5.495-4.994 5.495H68.564V41.717h-10.27l12.74-28.831H83.32l4.386 9.877v-9.877h15.208l2.64 7.443 2.658-7.443H120V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v72a4 4 0 0 0 4 4h112a4 4 0 0 0 4-4zm-8.026-11.882H120L109.384 52.86 120 41.73h-7.898l-6.556 7.165-6.493-7.165h-8.028l10.554 11.194-10.554 11.194h7.804l6.589-7.228zm1.878-11.249 6.148 6.54V46.384zm-35.78 6.067V55.45h12.633v-5.053H78.072V46.91h12.953v-5.182H71.965v22.388h19.062l-.001-5.181zm35.883-20.456H120V16.092h-9.403l-5.022 13.944-4.989-13.944h-9.563V38.48h6.044V22.808l5.758 15.672h5.373l5.757-15.704zm-29.809 0h6.877L81.14 16.092h-7.868L63.389 38.48h6.716l1.856-4.477h10.298zm-3.998-9.499h-6.077l3.039-7.324z"
  })));
};
export default SvgAmericanExpress;